import { render, staticRenderFns } from "./element.vue?vue&type=template&id=507dae2b&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=507dae2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507dae2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507dae2b')) {
      api.createRecord('507dae2b', component.options)
    } else {
      api.reload('507dae2b', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=507dae2b&scoped=true&", function () {
      api.rerender('507dae2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/product_detail/element.vue"
export default component.exports